import * as React from 'react'
import { FC, Fragment } from 'react'

import cn from 'classnames'

import getIconClass from '../../../../../misc/helpers/getIconClass'
import { Link } from '../../../../reusable/Link'
import styles from './CollapseMenu.module.scss'
import { ICollapseMenuProps } from './CollapseMenu.types'

export const CollapseMenu: FC<ICollapseMenuProps> = ({ menu, isVisible, toggleMenu }) => {

  return isVisible ? (
    <div className={styles.collapseMenuWrapper}>
      <ul className={styles.navLinks}>
        {menu.map((rootLink, index) => (
          <Fragment key={`m-${rootLink.id}-${index}`}>
            <li className={styles.link}>
              <Link to={rootLink.link} blank={rootLink.newWindow} onClick={toggleMenu}>
                {rootLink.title}
              </Link>
            </li>
            {rootLink.dropdownItems &&
              rootLink.dropdownItems.map((link, index) => (
                <li className={cn(styles.link, styles.dropdownLink)} key={`d-${rootLink.id}-${index}`}>
                  <Link to={link.link} blank={true} onClick={toggleMenu}>
                    ◦ {link.title}
                  </Link>
                </li>
              ))}
          </Fragment>
        ))}
      </ul>
      <div className={styles.social}>
        <Link
          className={cn(getIconClass.facebook, styles.icon)}
          to={'https://www.facebook.com/westminsterimmobilien'}
          onClick={toggleMenu}
          blank={true}
        />
        <Link
          className={cn(getIconClass.linkedIn, styles.icon)}
          to={'https://www.linkedin.com/company/westminster-unternehmensgruppe/'}
          onClick={toggleMenu}
          blank={true}
        />
      </div>
    </div>
  ) : null
}


